<template>
    <div>
        <div v-if="!isEdit" class="caption">Create a new team</div>
        <div class="caption" v-if="isEdit">Edit this team</div>

        <form>
            <b-field horizontal label="Name*:">
              <b-input
                  v-model="teamName"
                  placeholder="The great foxes"
                  maxlength="12"
              >
              </b-input>
            </b-field>

          <b-field horizontal label="Battle cry:">
            <b-input
                v-model="battleCry"
                placeholder="Yes we can!"
                maxlength="20"
            >
            </b-input>
          </b-field>

            <b-field horizontal label="Avatar:">
                <div style="position: relative">
                    <picture-input
                            ref="avatar"
                            @change="onPictureChosen"
                            width="250"
                            height="150"
                            margin="16"
                            accept="image/jpeg,image/png"
                            size="10"
                            :customStrings=" {
                    upload: '<h1>Bummer!</h1>',
                    drag: 'Choose Team Avatar'
                  }">
                    </picture-input>
                    <div v-if="imagePreviewUrl" id="injectedPreview" style="background-color: white">
                        <img id="injectedPreviewImage" v-bind:src="imagePreviewUrl"/>
                    </div>
                    <button v-if="imagePreviewUrl" @click.prevent="hideImagePreview"
                            class="button is-info is-outlined"
                            style="width: 250px; margin-top: 5px;">Change image
                    </button>
                </div>
            </b-field>

            <div class="control submit">
                <button
                        class="button is-light btn-margin"
                        @click.prevent="cancel()"
                >
                    Back to teams
                </button>
                <button @click.prevent="createTeam" class="button is-primary" v-if="!isEdit">Create team</button>
                <button @click.prevent="updateTeam" class="button is-primary" v-if="isEdit">Update team</button>
            </div>
        </form>
        <b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>
    </div>
</template>

<script>
  import teamsService from '../../services/teamsService'
  import PictureInput from 'vue-picture-input'
  import gamesService from '../../services/gamesService'
  import displayHelper from '../../helpers/display-helper'

  export default {
    data() {
      return {
        // for update
        isEdit: false,
        teamLoaded: null,
        teamId: null,
        oldGameName: null,
        imagePreviewUrl: '',

        //normal
        teams: [],
        teamName: '',
        password: '',
        battleCry: '',
        photoToUpload: null,
        photoUploaded: false,
        gameId: '',
        game: {},
        isLoading: false,
        title: 'Create new team'
      }
    },
    components: {
      PictureInput
    },
    async created() {
      try {
        if (this.$route.params.id) {
          this.gameId = this.$route.params.id
          this.game = await gamesService.getGameById(this.gameId)

          if (this.$route.params.idTeam) {
            this.isEdit = true
            this.teamId = this.$route.params.idTeam
            this.loadTeamById(this.gameId, this.teamId)
          }

        } else {
          displayHelper.displayError(this, 'Oops, there was an error, gameId was not provided in the url')
        }
      } catch (err) {
        displayHelper.displayError(this, 'Oops, there was an error: ' + err.message)
      }
    },
    methods: {
      async createTeam() {
        this.isLoading = true
        console.log('new team')
        const gameDetailsForTeamCreation = {
          idGame: this.game.idGame,
          gameName: this.game.gameName
        }
        const team = {
          teamName: this.teamName,
          password: 'geogaming',
          battleCry: this.battleCry,
        }

        const creationTeamResult = await teamsService.createTeam(
          team,
          gameDetailsForTeamCreation,
          this.photoToUpload,
          this.gameId
        )
        this.isLoading = false
        if (creationTeamResult.isSuccess) {
          const createdTeam = creationTeamResult.data
          this.teams.push(createdTeam)
          displayHelper.displaySuccess(this, 'Team has successfully been created')
          this.$router.back()

        } else {
          displayHelper.displayError(this, 'Oops, there was an error: ' + creationTeamResult.errors)
        }
      },
      cancel() {
        this.$router.go(-1)
      },
      hideImagePreview() {
        this.imagePreviewUrl = ''
      },

      onPictureChosen(photo) {
        if (photo) {
          this.photoToUpload = photo
        } else {
          console.log('FileReader API not supported: use the <form>, Luke!')
        }
      },

      loadTeamById(gameId, teamId) {
        this.isLoading = true
        var parent = this
        teamsService.getTeamById(gameId, teamId)
          .then((team) => {
            this.teamLoaded = team

            this.teamName = this.teamLoaded.teamName
            this.password = this.teamLoaded.password
            this.battleCry = this.teamLoaded.battleCry

            this.photoToUpload = this.teamLoaded.imageUrl
            this.imagePreviewUrl = this.teamLoaded.imageUrl
            this.oldGameName = this.teamLoaded.teamName

            this.isLoading = false
          })
          .catch((err) => {
            displayHelper.displayError(parent, 'Oops, there was an error: ' + err.message)
            this.isLoading = false
          })
      },
      async updateTeam() {
        this.isLoading = true
        var parent = this
        const theGame = {
          idGame: this.game.idGame,
          gameName: this.game.gameName
        }
        const team = {
          idTeam: this.teamId,
          teamName: this.teamName,
          password: this.password,
          battleCry: this.battleCry,
          oldGameName: this.oldGameName,
        }

        const updateTeamResult = await teamsService.updateTeam(
          team,
          theGame,
          this.photoToUpload,
          this.gameId
        )
        this.isLoading = false
        if (updateTeamResult.isSuccess) {
          const updatedTeam = updateTeamResult.data
          // TODO: mettre à jour et pas push les teams
          this.teams.push(updatedTeam)
          displayHelper.displaySuccess(this, 'Team has successfully been updated')
          this.$router.back()

        } else {
          displayHelper.displayError(parent, 'Oops, there was an error: ' + updateTeamResult.errors)
        }
      },
    }
  }
</script>

<style scoped>
    .team-form .is-horizontal .field-label {
        flex-grow: 0;
    }

    .team-form label {
        margin-bottom: 0;
        /* width: 50% !important; */
    }

    .team-form .column .field {
        align-items: center;
    }

    .picture-input /deep/ .preview-container {
        margin: 0;
        z-index: 1 !important;
    }

    .picture-input /deep/ .picture-preview {
        margin: 0;
        z-index: 1 !important;
    }

    .picture-input /deep/ .picture-inner {
        z-index: 1 !important;
    }

    .picture-input {
        text-align: left !important;
    }

    .picture-input /deep/ .preview-container {
        margin: 0;
    }

    input[type='number'] {
        -moz-appearance: textfield;
    }

    .caption {
        font-weight: bold;
        font-size: 1.2em;
        margin-bottom: 5px;
    }

    .btn-margin {
        margin-left: 10px;
        margin-right: 10px;
    }

    #pictureInput, #injectedPreview {
        height: 150px;
        width: 250px;
        position: absolute;
    }

    #injectedPreviewImage {
        height: 150px;
        width: 250px;
    }

    #injectedPreview {
        top: 0;
        z-index: 10;
    }
</style>
